import React, {useEffect, useState} from "react";

import axios from "config/axiosConfig";
import {useLocation, useNavigate} from "react-router-dom";
import DatePicker from "react-datepicker";
import dateFormat, { masks } from "dateformat";
import 'react-datepicker/dist/react-datepicker.css';

export default function Detail() {
    const [content, setContent] = useState();

    const [handleStartDate, setHandleStartDate] = useState();
    const [handleEndDate, setHandleEndDate] = useState();
    const [handleLinkUrl, setHandleLinkUrl] = useState();
    const [handleMembership, setHandleMembership] = useState();
    const [handleFile, setHandleFile] = useState();

    const navigate = useNavigate();
    const location = useLocation();

    const queryParams = new URLSearchParams(location.search); // 쿼리 파라미터 추출
    const id = queryParams.get("id");

    const requestData = () => {
        if (id !== null && id !== "") {
            axios.get(`/admin/image-popups/${id}`)
                .then((res) => {
                    setContent(res.data);
                    setHandleStartDate(res.data.startAt);
                    setHandleEndDate(res.data.endAt);
                    setHandleLinkUrl(res.data.linkUrl);
                    setHandleMembership(res.data.membership);
                });
        }
    }

    const requestSave = async () => {
        if (handleFile === null) {
            alert("파일을 확인해주세요.");
            return;
        }

        const formData = new FormData();
        formData.append("file", handleFile);
        const uploadedFileRes = await axios.post('/admin/upload/file', formData, {
            headers: {'Content-Type': 'multipart/form-data'}
        })

        console.log(uploadedFileRes.data.accessUrl);
        debugger;
        const params = {}
        params.imageUrl = uploadedFileRes.data.accessUrl;
        params.linkUrl = handleLinkUrl;
        params.startAt = handleStartDate;
        params.endAt = handleEndDate;
        params.membership = handleMembership;

        const savedRes = await axios.post(`/admin/image-popups`, JSON.stringify(params))
        if (savedRes.status === 200) {
            alert('생성 되었습니다.');
            navigate(-1);
        }
    }

    useEffect(() => {
        requestData()
    }, []);

    return (
        <div className="App">
            <div className="wrapper">
                <div className="content-wrapper" style={{marginLeft: '0px'}}>
                    <div className="content-header">
                        <div className="container-fluid">
                            <div className="row mb-2">
                                <div className="col-sm-12">
                                    <ol className="breadcrumb">
                                        <li className="breadcrumb-item active">메인화면-노무지식-상세</li>
                                    </ol>
                                </div>
                            </div>
                        </div>
                    </div>

                    <section className="content">
                        <div className="container-fluid">
                            <div className="row">
                                <div className="card card-secondary col-sm-12">
                                    <div className="card-body">

                                        <div className="row">
                                            <label htmlFor="input-title"
                                                   className="col-form-label col-sm-1"
                                                   style={{marginLeft: "8px"}}>시작일</label>
                                            <div className="col-sm-10" style={{paddingTop: "5px"}}>
                                                <DatePicker
                                                    dateFormat="yyyy-MM-dd'T'HH:mm:ss"
                                                    dateFormatCalendar="yyyy년 MM월"
                                                    locale="ko"
                                                    selected={handleStartDate}
                                                    onChange={date => {
                                                        setHandleStartDate(date)
                                                    }}
                                                    showTimeSelect
                                                />
                                            </div>
                                        </div>
                                        <div className="row">
                                            <label htmlFor="input-title"
                                                   className="col-form-label col-sm-1"
                                                   style={{marginLeft: "8px"}}>종료일</label>
                                            <div className="col-sm-10" style={{paddingTop: "5px"}}>
                                                <DatePicker
                                                    dateFormat="yyyy-MM-dd'T'HH:mm:ss"
                                                    dateFormatCalendar="yyyy년 MM월"
                                                    locale="ko"
                                                    selected={handleEndDate}
                                                    onChange={date => {
                                                        setHandleEndDate(date)
                                                    }}
                                                    showTimeSelect
                                                />
                                            </div>
                                        </div>

                                        <div className="row" style={{marginTop: "10px"}}>
                                            <label htmlFor="input-sub-title"
                                                   className="col-form-label col-sm-1"
                                                   style={{marginLeft: "8px"}}>링크</label>
                                            <div className="col-sm-10">
                                                <input id="input-link-url"
                                                       type="text"
                                                       className="form-control"
                                                       onChange={event => {
                                                           setHandleLinkUrl(event.target.value);
                                                       }}
                                                       value={handleLinkUrl ?? ""}
                                                />
                                            </div>
                                        </div>

                                        <div className="row" style={{marginTop: "10px"}}>
                                            <label className="col-form-label col-sm-1"
                                                   style={{marginLeft: "8px"}}>대상멤버십</label>
                                            <div className="col-sm-10">
                                                <select id="input-visible"
                                                        className="form-control"
                                                        style={{width: '200px', marginRight: '10px'}}
                                                        onChange={event => {
                                                            setHandleMembership(event.target.value);
                                                        }}
                                                        value={handleMembership}>
                                                    <option value="">전체</option>
                                                    <option value="BASIC">BASIC</option>
                                                    <option value="BUSINESS">BUSINESS</option>
                                                </select>
                                            </div>
                                        </div>

                                        <div className="row" style={{marginTop: "10px"}}>
                                            <label className="col-form-label col-sm-1"
                                                   style={{marginLeft: "8px"}}>파일</label>
                                            <div className="col-sm-10" style={{paddingTop: "5px"}}>
                                                <input
                                                    className='file-input'
                                                    type="file"
                                                    onChange={event => {
                                                        setHandleFile(event.target.files[0]);
                                                    }}
                                                />
                                            </div>
                                        </div>

                                    </div>
                                </div>
                            </div>
                        </div>
                    </section>

                    <div className="row">
                        <div style={{margin: "0 auto"}}>
                            <button type="button" className="btn btn-outline-secondary"
                                    onClick={event => {navigate(-1)}}>
                                목록
                            </button>
                            <button type="button" className="btn btn-outline-primary"
                                    style={{marginLeft: "10px"}}
                                    onClick={requestSave}>
                                {id === null ? '저장' : '수정'}
                            </button>
                        </div>
                    </div>

                </div>
            </div>
        </div>
    )
}